import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
const ItemIsNotReady = (item: SmartSendItemApiModel) =>
  item.Status === 'Active' && item.MarketplaceStatus === 'Sold' && item.State?.validation?.Validated !== true;
export default ItemIsNotReady;
